import './components/utils/errorReporting';
import './components/utils/translateSafeDom';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import TagManager from 'react-gtm-module';
import 'bootstrap/dist/css/bootstrap.min.css';
import './i18n';

// Initialize GTM once when the app starts
const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

// Auto-update mechanism: Check for new deployments
if (process.env.NODE_ENV === 'production') {
  let currentVersion: string | null = null;

  const checkForUpdate = async () => {
    try {
      const response = await fetch('/asset-manifest.json?_=' + Date.now(), {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      
      if (!response.ok) return;
      
      const manifest = await response.json();
      // Get the main.js file hash which changes with each build
      const mainJsFile = manifest.files?.['main.js'] || 
                         manifest.entrypoints?.find((f: string) => f.includes('main.js')) ||
                         JSON.stringify(manifest);
      
      if (currentVersion === null) {
        // First check - just store the version
        currentVersion = mainJsFile;
      } else if (currentVersion !== mainJsFile) {
        // Version changed - reload the page
        console.log('New version detected, reloading...');
        window.location.reload();
      }
    } catch (error) {
      // Silently ignore network errors
      console.debug('Version check failed:', error);
    }
  };

  // Initial check after a short delay to let the app initialize
  setTimeout(checkForUpdate, 5000);
  
  // Check every 60 seconds
  setInterval(checkForUpdate, 60000);
  
  // Check when user returns to tab
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      checkForUpdate();
    }
  });
}

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. This comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
